import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {SubscriptionService} from '@app/app/subscription/subscription.service';
import {carouselEnum} from '@app/components/carousel/iCarousel';
import {CacheObjectService, DeviceService, EventTrackerService} from '@app/core';
import {AppParametersService} from '@app/core/token/app-parameters.service';
import {CheckHtml5Service} from '@app/helper/check-html5.service';
import {ScrollToLastPosition} from '@app/helper/scroll-to-last-position';
import {ProductTypeEnum} from '@app/interfaces/iBook';
import {iIndexItems} from '@app/interfaces/iIndexItems';
import {IndicatorService} from '@app/shared';
import {filter, map} from 'rxjs/operators';

import {IMainPageItem} from '../ibook-shop';
import {ShopService} from '../shop.service';
import {genreEnum} from './../ibook-shop';
import {ClientTypeEnum} from "@app/helper/ClientTypeEnum";

@Component({
  selector: "navaar-shop",
  templateUrl: "./shop.component.html",
  styleUrls: ["./shop.component.scss"],
  host: {
    style: "scroll-behavior: smooth",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShopComponent extends ScrollToLastPosition implements OnInit {
  public carouselType: typeof carouselEnum = carouselEnum;
  public productType: typeof ProductTypeEnum = ProductTypeEnum;
  public eventTrackerName: string = 'x_shop_item_click';
  public categoryShop = [
    {
      name: "کتاب صوتی",
      class: "bg-orange",
      id: 38,
      contentType: ProductTypeEnum.AudioBook
    },
    {
      name: "کپسول",
      class: "bg-bright-cyan",
      id: 24,
      contentType: ProductTypeEnum.Capsule
    },
    {
      name: "سریال صوتی",
      class: "bg-blue",
      id: 39,
      contentType: ProductTypeEnum.AudioSeries
    },
    {
      name: "پادکست",
      class: "bg-purple",
      id: 60,
      contentType: ProductTypeEnum.Podcast
    }
  ];
  public genre: typeof genreEnum = genreEnum;
  public shop: Array<iIndexItems>;

  public currentPage: number = 0;
  public clientTypeEnum: typeof ClientTypeEnum = ClientTypeEnum;
  public skip: number = 0;
  public readonly PAGE_SIZE = 10;
  public pages: number = 0;
  public total: number = 0;
  public isLoading: boolean = false;
  public isEnd: boolean = false;
  public showOldVersion: boolean = false;

  public get pageNo(): number {
    return this.cache.pageNumer;
  }

  public set pageNo(v: number) {
    this.cache.pageNumer = v;
  }

  constructor(
    public readonly parametersService: AppParametersService,
    private readonly checkHtml5Service: CheckHtml5Service,
    private readonly shopServices: ShopService,
    public readonly indicator: IndicatorService,
    private readonly cache: CacheObjectService<Array<IMainPageItem> | any>,
    public readonly device: DeviceService,
    private readonly eventTracker: EventTrackerService,
    private readonly chkd: ChangeDetectorRef,
    private readonly subscriptionService: SubscriptionService,
    private readonly router: Router
  ) {
    super(router);
    this.device.hide();
    this.subscriptionService.isEndedSubscription$.subscribe((c) => {
      if (c) this.subscriptionService.setStatusEndedRemainigSubscription(true);
    });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (event.restoredState) this.shopServices.isBackFromItem = true;
      });
  }

  public async ngOnInit() {
    this.checkSupportHtml();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (event.restoredState) this.shopServices.isBackFromItem = true;
      });
    this.shop = [];
    await this.loadBookAllList();
  }

  private checkSupportHtml() {
    let supportVideo = this.checkHtml5Service.supports_video();
    let supportsCanvas = this.checkHtml5Service.supports_canvas();
    if (!supportVideo) {
      this.showOldVersion = true;
    }
    if (!supportsCanvas) {
      this.showOldVersion = true;
    }
  }

  public goToPage(page: number) {
    this.paginate(page);
  }

  public paginate(page) {
    this.pageNo = page;
    this.skip = this.pageNo * this.PAGE_SIZE;
    this.shopServices.isBackFromItem = false;
    this.loadBookAllList().then();
  }

  public async loadBookAllList() {
    this.isLoading = true;
    const clientId = this.parametersService.clientId;
    const url = `/api/indexitem/shop?clientId=${clientId}`;
    let Url = `${url}&$inlinecount=allpages`;
    if (this.skip != undefined) {
      Url += `&$skip=${this.skip}`;
    }
    if (this.PAGE_SIZE != undefined) {
      Url += `&$top=${this.PAGE_SIZE}`;
    }
    await this.cache
      .getObjectCacheOfList(Url, 'shop-list', this.pageNo).pipe(
        map((res) => {
          this.isLoading = false;
          this.isEnd = res.items.length === res.total;
          this.shop = res.items;
          this.total = res.total;
          this.pages = Math.ceil(this.total / this.PAGE_SIZE);
          this.indicator.hide();
          this.indicator.hideHude();
          this.chkd.detectChanges();
          return res;
        })
      )
      .toPromise();
    if (this.shopServices.isBackFromItem) super.scrollToPosition();
  }

  public goToWeb() {
    this.trackerEvents({
      x_item_name: 'old_device_go_to_web'
    });
    this.device.goToWebWithToken();
  }

  public trackerEvents(item: object) {
    this.eventTracker.logEvent(this.eventTrackerName, item);
  }
}
